const shortWeekdays = (text: string) => text
	.replace('Montag', 'Mo')
	.replace('Dienstag', 'Di')
	.replace('Mittwoch', 'Mi')
	.replace('Donnerstag', 'Do')
	.replace('Freitag', 'Fr')
	.replace('Samstag', 'Sa')
	.replace('Sonntag', 'So')

	export default shortWeekdays;
